import { render, staticRenderFns } from "./StorePopupSummary.vue?vue&type=template&id=3ec5b53e&"
import script from "./StorePopupSummary.vue?vue&type=script&lang=js&"
export * from "./StorePopupSummary.vue?vue&type=script&lang=js&"
import style0 from "./StorePopupSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec5b53e')) {
      api.createRecord('3ec5b53e', component.options)
    } else {
      api.reload('3ec5b53e', component.options)
    }
    module.hot.accept("./StorePopupSummary.vue?vue&type=template&id=3ec5b53e&", function () {
      api.rerender('3ec5b53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Store/modal/StorePopupSummary.vue"
export default component.exports